/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

export const QuotationRoutes = {
  LIST: 'list',
  EDIT: '/quote/edit/:idProduct',
  ADD: '/quote/add',
};
